var app = angular.module("leonardo");

var VendorCategoryAddDialog = function($scope, $rootScope, CategoryVendorService, AccountUserService,
                                       NotificationService, FormErrorsService) {
  $scope.data = angular.copy($scope.ngDialogData.category);
  $scope.mode = $scope.ngDialogData.mode;

  if (!$scope.data) {
    $scope.data = {};
  }

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = angular.copy($scope.data);
    if (AccountUserService.currentAccountUser) {
      data['account_membership'] = AccountUserService.currentAccountUser.account;
    }
    if ($scope.mode === 'create') {
      CategoryVendorService.post(data).then(function(result) {
        CategoryVendorService.updateCollection(result);
        $rootScope.$broadcast('vendor-category:added');
        $scope.closeThisDialog();
      });
    }
    else if ($scope.mode === 'edit') {
      $scope.data.patch(data).then(function(){
        $rootScope.$broadcast('vendor-category:added');
        $scope.closeThisDialog();
      });
    }
  };
};

app.controller('VendorCategoryAddDialog', ['$scope', '$rootScope', 'CategoryVendorService', 'AccountUserService',
  'NotificationService', 'FormErrorsService', VendorCategoryAddDialog]);
